import { useFormik } from "formik";
import { useRouter } from "next/router";
import * as yup from 'yup';
import { useToast } from "@netfront/ekardo-content-library";
import { Button, Input } from "@netfront/ui-library";
import { IForgotPasswordFormFields } from "./ForgotPasswordForm.interfaces";
import { IForgotPasswordOnCompletedResponse, useForgotPassword } from '@netfront/gelada-identity-library';

export const ForgotPasswordForm = () => {
    const { push } = useRouter();
    const { handleToastError } = useToast();

    const handleForgotPasswordCompleted = ({ isCompleted }: IForgotPasswordOnCompletedResponse) => {
      if(!isCompleted) return;
      push('/forgot-password-sent');
    };

    const { handleForgotPassword, isLoading: isSubmitting = false } = useForgotPassword({
      onCompleted: handleForgotPasswordCompleted,
      onError: (error) => {
        handleToastError({
          error,
          shouldUseFriendlyErrorMessage: true,
        });
      },
    });
    
    const formik = useFormik<IForgotPasswordFormFields>({
      initialValues: {
        email: '',
        confirmEmail: '',
      },
      validationSchema: yup.object().shape({
        email: yup.string().email('Please enter a valid email address').required('Please enter in a valid email address'),
        confirmEmail: yup.string()
          .required('Please confirm your email address')
          .oneOf([yup.ref('email')], 'Email addresses do not match'),
      }),
      onSubmit: async ({ email }: IForgotPasswordFormFields) => {
        handleForgotPassword({
          email,
        });
      }
    });

    const { errors, touched, handleBlur, handleChange, handleSubmit, isValid, dirty } = formik;
  
    return (
      <form onSubmit={handleSubmit}>
        <Input
          errorMessage={touched.email && errors.email ? errors.email : ''}
          id='email'
          labelText='Email'
          placeholder='Enter email'
          name='email'
          onBlur={handleBlur}
          onChange={handleChange}
          type='email'
          isRequired
        />

        <Input
          errorMessage={touched.confirmEmail && errors.confirmEmail ? errors.confirmEmail : ''}
          id='confirmEmail'
          labelText='Confirm email'
          placeholder='Re-enter email'
          name='confirmEmail'
          onBlur={handleBlur}
          onChange={handleChange}
          type='email'
          isRequired
        />

        <Button
          additionalClassNames='w-full'
          variant='tertiary'
          text='Send reset link'
          type='submit'
          isDisabled={isSubmitting || !isValid || !dirty}
          isLoading={isSubmitting}
        />
      </form>
    )
};